import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "./chunks/tslib.es6.js";
import t from "./Camera.js";
import { geometryTypes as e } from "./geometry.js";
import { JSONSupport as o } from "./core/JSONSupport.js";
import { isSome as s } from "./core/maybe.js";
import { property as i } from "./core/accessorSupport/decorators/property.js";
import "./core/arrayUtils.js";
import "./core/has.js";
import { cast as a } from "./core/accessorSupport/decorators/cast.js";
import { subclass as c } from "./core/accessorSupport/decorators/subclass.js";
import { fromJSON as p } from "./geometry/support/jsonUtils.js";

var _m;

var n = _m = /*#__PURE__*/function (_o) {
  _inherits(m, _o);

  var _super = _createSuper(m);

  function m(r) {
    var _this;

    _classCallCheck(this, m);

    _this = _super.call(this, r), _this.rotation = 0, _this.scale = 0, _this.targetGeometry = null, _this.camera = null;
    return _this;
  }

  _createClass(m, [{
    key: "castRotation",
    value: function castRotation(r) {
      return (r %= 360) < 0 && (r += 360), r;
    }
  }, {
    key: "clone",
    value: function clone() {
      return new _m({
        rotation: this.rotation,
        scale: this.scale,
        targetGeometry: s(this.targetGeometry) ? this.targetGeometry.clone() : null,
        camera: s(this.camera) ? this.camera.clone() : null
      });
    }
  }]);

  return m;
}(o);

function l() {
  return {
    enabled: !this.camera
  };
}

r([i({
  type: Number,
  json: {
    write: !0,
    origins: {
      "web-map": {
        default: 0,
        write: !0
      },
      "web-scene": {
        write: {
          overridePolicy: l
        }
      }
    }
  }
})], n.prototype, "rotation", void 0), r([a("rotation")], n.prototype, "castRotation", null), r([i({
  type: Number,
  json: {
    write: !0,
    origins: {
      "web-map": {
        default: 0,
        write: !0
      },
      "web-scene": {
        write: {
          overridePolicy: l
        }
      }
    }
  }
})], n.prototype, "scale", void 0), r([i({
  types: e,
  json: {
    read: p,
    write: !0,
    origins: {
      "web-scene": {
        read: p,
        write: {
          overridePolicy: l
        }
      }
    }
  }
})], n.prototype, "targetGeometry", void 0), r([i({
  type: t,
  json: {
    write: !0
  }
})], n.prototype, "camera", void 0), n = _m = r([c("esri.Viewpoint")], n);
var u = n;
export { u as default };